module.exports = {"title":"Ooops, something went wrong","description":"Please take a look at the logs to see why the scan has failed.","checkout":"Check Out","ok":"OK"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkin/WrongModal/locales/en.json
// module id = 1383
// module chunks = 0